const MediaAdviserTypeEnum = Object.freeze({
    FEES: 'FEES',
    TERMS: 'TERMS'
});

export default MediaAdviserTypeEnum;
